import { Deserializer } from 'jsonapi-serializer';
import { genericError } from "../models/GenericError";
import { ListQuery } from "../models/ListQuery";
import { Name } from "../models/Name";
import { PaginationModel } from "../models/Pagination";
import { APIConnector } from "./api/APIConnector";
import { createPagination } from "./utilities/paginationBuilder";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";
import { createPartialURL, getFilterClause } from "./utilities/urlBuilder";

const apiConnector = new APIConnector();

export const getThreatLevelNames = async (listParameters?: ListQuery): Promise<{ rows: Name[], pagination: PaginationModel }> => {
    try {
        const filter = getFilterClause(listParameters?.filters, listParameters?.searchTerm);
        const paginationString = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filter);
        const url = `threatLevel?fields[threatLevel]=tlName${paginationString}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const newPagination = createPagination(json.meta);


        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail), success: false })
            }

            new Deserializer().deserialize(json, (err: any, items: any[]) => {
                if (err) {
                    return reject({status: response.status, message: genericError });
                }
                const threatLevels: Name[] = items.map((threatLevel): Name => {
                    return {
                        value: threatLevel['id'],
                        label: threatLevel['tl-name']
                    };
                });
                return resolve({ rows: threatLevels, pagination: newPagination });
            })
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
